import { SaleProductCard } from "@/components";

interface SaleProductsProps {
	saleProductsData?: SaleProduct[];
}

const SaleProducts = ({ saleProductsData }: SaleProductsProps) => {
	return (saleProductsData ?? []).map((saleProduct) => (
		<SaleProductCard saleProduct={saleProduct} key={saleProduct.id} />
	));
};

export default SaleProducts;
